import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "@hello-pangea/dnd";
import EditableSection from "../editableSection/EditableSection";
import { DraggableSectionListProps } from "../../types/componentsConstructors";
import {
  DraggableItemWrapper,
  ListContainer,
} from "./DraggableSectionListStyles";

const DraggableSectionList = ({
  sections,
  setSections,
  onDelete,
  onChange,
}: DraggableSectionListProps) => {
  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reordered = Array.from(sections);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    setSections(reordered);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="section-list">
        {(provided) => (
          <ListContainer ref={provided.innerRef} {...provided.droppableProps}>
            {sections.map((section, index) => {
              if (section.type === "imageGroup") return null;

              const content = (
                <EditableSection
                  key={section.id}
                  title={section.title}
                  type={section.type}
                  value={section.value}
                  onChange={(val) => onChange(section.id, val)}
                  onDelete={() => onDelete(section.id)}
                />
              );

              return (
                <Draggable
                  key={section.id}
                  draggableId={section.id}
                  index={index}
                >
                  {(provided) => (
                    <DraggableItemWrapper
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {content}
                    </DraggableItemWrapper>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </ListContainer>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableSectionList;
